import { isEmpty } from 'lodash';

export function isAssetValid(value?: string | null): boolean {
  return !isEmpty(value);
}

export function isDestinationSpotValid(value?: string | null): boolean {
  return !isEmpty(value);
}

export function isMoveDetailsValid(
  asset?: string | null,
  destinationSpot?: string | null
): boolean {
  return isAssetValid(asset) || isDestinationSpotValid(destinationSpot);
}
